import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    eventoId: 0,
    sorteoGlobalId: 0,
    refId: 0,
    endPoint: '',
    cliente: '',
    sorteoNombre: '',
    tipoEventoId: 0,

    sorteoId: 0,
    fechaSorteo: '1900-01-01',

    soloClientes: false,
    dobleChanceClientes: false,

    participantes: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    nombre: '',
    documentoNumero: '',
    // sortByDescending: false,

    participanteDatos: [],
    participantesList: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_SORTEO' (state, params) {
        state.eventoId = params.eventoId;
        state.sorteoGlobalId = params.sorteoGlobalId;
        state.refId = params.eventoId | params.sorteoGlobalId;
        state.endPoint = params.eventoId ? 'evento' : 'sorteo-global'
        state.cliente = '';
        state.sorteoNombre = '';
        state.tipoEventoId = 0;

        state.soloClientes = false;
        state.dobleChanceClientes = false;

        state.sorteoId = 0;
        state.fechaSorteo = '1900-01-01';
        state.participantes = [];
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
        state.nombre = '';
    },
    'SET_SORTEO' (state, sorteo) {
        state.sorteoId = sorteo.id;
        state.cliente = sorteo.cliente.trim();
        state.sorteoNombre = sorteo.nombre.trim();
        state.fechaSorteo = moment(sorteo.fechaSorteo).format('YYYY-MM-DD HH:mm');
        state.tipoEventoId = sorteo.tipoEventoId;
    },
    'SET_PARTICIPANTES' (state, participantes) {
        state.participantes = participantes;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST' (state) {
        state.participantesList = [];
    },
    'SET_LIST' (state, participantesList) {
        state.participantesList = participantesList;
    },
};

const getters = {
    getField,

    participantesList(state) {
        return state.participantesList;
    }
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SORTEO', params);

            apiAxios.get('sorteos/' + state.endPoint.trim()+ '/' + state.refId)
                .then(res => {
                    if (res.status == 200) {
                        commit('SET_SORTEO', res.data);
                    }
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getParticipantes ( { commit } ) {
        return new Promise((resolve, reject) => {
            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
            
            if (state.nombre.trim() != '') {
                queryString += '&nombre=' + state.nombre.trim();
            }
            
            apiAxios.get('sorteos/' + state.endPoint.trim()+ '/' + state.refId + '/participantes' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }
                    commit('SET_PARTICIPANTES', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    sortear ( {}, params) {
        return new Promise((resolve, reject) => {
            // let params= {
            //     soloClientes: (/true/i).test(params.soloClientes),
            //     dobleChanceClientes: (/true/i).test(params.dobleChanceClientes),
            // };

            let url = '';
            if (params.eventoId != 0) {
                url = 'sorteos/evento/' + params.eventoId + '/sortear';
            } else {
                url = 'sorteos/sorteo-global/' + params.sorteoGlobalId + '/sortear';
            }

            apiAxios.post(url, params)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getParticipantesList ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('sorteos/' + state.endPoint.trim()+ '/' + state.refId + '/participantes/list')
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    // getDatos ( { commit }, participanteId ) {
    //     return new Promise((resolve, reject) => {
    //         commit('INICIALIZAR_DATOS');

    //         if (participanteId) {
    //             apiAxios.get('participantes/' + participanteId ) 
    //                 .then(res => {
    //                     let participanteDatos = [
    //                         // { 'nombre': 'apellido', 'campo': 'Apellido', 'valor': res.data.apellido, 'formato': '' },
    //                         // { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
    //                         { 'nombre': 'nombreCompleto', 'campo': 'Apellido y Nombre', 'valor': res.data.nombreCompleto, 'formato': '' },
    //                         { 'nombre': 'fechaNacimiento', 'campo': 'Fecha de Nac.', 'valor': res.data.fechaNacimiento, 'formato': 'fecha' },
    //                         { 'nombre': 'documentoNumero', 'campo': 'Nro.Documento', 'valor': res.data.documentoNumero, 'formato': '' },
    //                     ]

    //                     let params = {
    //                         participanteDatos,
    //                     }
                                      
    //                     commit('SET_DATOS', params);
    //                     resolve();
    //                 })
    //                 .catch(error => reject(helpers.methods.getErrorMessage(error)));
    //         }
    //     })
    // },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}